import { render } from "./ByCallIcon.vue?vue&type=template&id=79e32346"
import script from "./ByCallIcon.vue?vue&type=script&lang=js"
export * from "./ByCallIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__